export const trainingVideoSelector = (state: any) => {
    return state.trainingVideo;
}